import axios from "axios";
import { SignHeader } from "components/HeaderTitleComponent";
import Loading from "components/Loading";
import { SelectOption } from "components/input/Input";
import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { ClassInfo, SiteInfo, provinceInfo } from "type/type";
import {  checkLoginPage } from "./LoginWrap";
import {
  API_URL,
  NODATATEXT,
  aesCBCDecrypt,
  aesCBCEncrypt,
  getAccessToken,
} from "utils/commonUtils";
import {
  getSignClass,
  getSite,
  postSignSite,
  postSignUser,
} from "api/api";
import { NoDataWithImageText } from "components/NoDataComponent";
import { colors } from "styles/global-styles";
import { SignContext } from "./Sign";

const MainWrap = styled.main`
  max-height: 750px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 580px;
  border-radius: 1rem;
  padding: 3.75rem 4.375rem 2.5rem;
  gap: 1.5rem;
  background-color: ${({theme}) => theme.rootWhite};
  position: relative;
  button {
    margin-top: auto;
    width: 100%;
    color: ${({theme}) => theme.newTheme.text.btnText_w};
    font-size: 0.875rem;
    font-weight: 600;
  }
  :not(:disabled).main-btn {
    background-color: ${({theme}) => theme.newTheme.default.primary};
    &:not(:disabled):hover {
      background-color: ${colors.primaryHover};
    }
  }
  .devide-section-wrap {
    overflow: auto;
    padding-right: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;
const MainSection = styled.section`
  &.devide-section:first-of-type {
    border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
    padding-bottom: 1.5rem;
  }
  &.one-section {
    height: calc(100% - 190px);
  }
  display: flex;
  flex-direction: column;
  gap: 1rem;
  
  .default-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  .default-button-wrap {
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    flex-wrap: wrap;
    label {
      width: 100%;
    }
    input[type="text"] {
      width: calc(100% - 6rem);
    }
    button {
      width: 5rem;
      color: ${({theme}) => theme.newTheme.default.accent};
      height: 2.5rem;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
      background-color: ${({theme}) => theme.newTheme.default.secondary};
      &:hover {
        background-color: ${colors.primaryHover};
      }
    }
  }
  .teacher-main-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 1rem 0.5rem;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      width: calc((100% - 1rem) / 2);
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      position: relative;
      &:last-of-type {
        width: 100%;
      }
    }
  }
  .director-main-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 1rem 0.5rem;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      position: relative;
    }
  }
  label {
    font-weight: 600;
  }
  .search-icon {
    display: inline-flex;
    position: absolute;
    top: 2rem;
    right: 1rem;
    color: ${({theme}) => theme.newTheme.text.btnText_disabled};
    &:hover {
      cursor: pointer;
    }
  }
  .add-class-wrap {
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    button {
      width: 5rem;
      color: ${({theme}) => theme.newTheme.default.accent};
    }
  }
  .required_value::after {
    position: absolute;
    content: "*";
    color: ${({theme}) => theme.newTheme.default.error};
  }
`;
const DataResultWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
  > nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    color: ${({theme}) => theme.newTheme.text.btnText_disabled};
    p {
      font-size: 14px;
    }
    .search-result-count {
      color: ${({theme}) => theme.rootBlack};
    }
  }
`;
const CenterOneContainer = styled.div`
  padding: 0.75rem 0;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  label {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.25rem;
  }
  input {
    -webkit-appearance: none; // 웹킷 브라우저에서 기본 스타일 제거
    -moz-appearance: none; // 모질라 브라우저에서 기본 스타일 제거
    appearance: none; // 기본 브라우저에서 기본 스타일 제거
    width: 1.25rem;
    height: 1.25rem;
    margin: 0.25rem;
    border-radius: 50%;
    padding: 0.25rem;
    border: 1px solid ${({theme}) => theme.newTheme.border.thirdBd};
    background-color: ${({theme}) => theme.rootWhite};
    outline: none;
    cursor: pointer;
    &:checked {
      border: 3px solid ${({theme}) => theme.rootWhite}; // 테두리가 아닌, 테두리와 원 사이의 색상
      background-color: ${({theme}) => theme.newTheme.default.primary}; // 체크 시 내부 원으로 표시될 색상
      box-shadow: 0 0 0 1px ${({theme}) => theme.newTheme.default.primary};
    }
  }
  p {
    font-size: 14px;
    &:first-of-type {
      font-size: 1rem;
      color: ${({theme}) => theme.newTheme.default.primary};
    }
    &:last-of-type {
      color: ${({theme}) => theme.newTheme.text.btnText_disabled};
    }
  }
`;

type selectDataType = {
  province: number;
  district: number;
};

type signSiteInfo = {
  center_name: string;
  name: string;
  full_address: string;
  address_detail: string;
  phone: string;
  telephone: string;
  email: string;
};
// 다음주소 팝업창 theme
export const themeObj = {
  bgColor: "#162525", //바탕 배경색
  searchBgColor: "#162525", //검색창 배경색
  contentBgColor: "#162525", //본문 배경색(검색결과,결과없음,첫화면,검색서제스트)
  pageBgColor: "#162525", //페이지 배경색
  textColor: "#FFFFFF", //기본 글자색
  queryTextColor: "#FFFFFF", //검색창 글자색
  outlineColor: "#444444", //테두리
};
// 공공데이터
let tokenData: any;


// [선생님] - 반 선택 등록
export function RegisterClass() {
  // ************************************ prop

  const signContext = useContext(SignContext);
  if (!signContext) {
    throw new Error("SignContext must be used within a SignProvider");
  }
  const { signData, setSignData } = signContext;
  const navigate = useNavigate();

  // ************************************ state

  const [selectData, setSelectData] = useState(0);
  // 반 선택 select-option
  const [selectOptionClass, setSelectOptionClass] = useState<provinceInfo[]>([
    { label: "반 미정", value: 0 },
  ]);
  const [isRequired, setIsRequired] = useState(false);

  // ************************************ handle

  // 반 선택
  function handleChangeOption(prop: number) {
    setSelectData(prop);
    setSignData((prev) => ({
      ...prev,
      class_id: prop,
    }));
  }

  // 선택한 업장에 있는 반 데이터 가져오기
  async function getApiData() {
    try {
      const result = await getSignClass(signData.site_id);

      if (result.code === 200) {
        let array: any[] = [{ label: "반 미정", value: 0 }];
        // result.data로 forEach하기
        result.data.forEach((d: ClassInfo) => {
          let option = { label: d.name, value: d.id };
          array.push(option);
        });
        setSelectOptionClass(array);
      } else {
        alert(result.message);
        return;
      }
    } catch (error) {
      console.error("API error ", error);
    }
  }

  async function goToNextPage(page: string) {

    if (!signData.site_id) {
      navigate("/login/sign");
      return;
    }

    // 회원가입이 정상적으로 진행되면 welcome 페이지로 이동
    const result = await postSignUser(signData, signData.site_id);

    if (result.code === 200) navigate(`/login/${page}`);
    else {
      // alert(result.message);
      const goToLogin = window.confirm(
        `${result.message} 처음으로 돌아가시겠습니까?`
      );
      if (goToLogin) navigate("/login/sign");
      return;
    }
  }
  
  // ************************************ useEffect

  useEffect(() => {
    setIsRequired(true);
  }, [selectData]);
  
  useEffect(() => {
    if (!checkLoginPage && (!sessionStorage.getItem("sessionData") || !sessionStorage.getItem("sessionData")?.includes("user"))) {
      navigate(`/login/sign`);
      return;
    }

    getApiData();
  }, []);

  return (
    <MainWrap>
      <SignHeader
        title1={`${signData.site?.name}`}
        title2={"무슨 반을 담당 하시나요?"}
        page={5}
      />
      <MainSection>
        <div className="default-wrap">
          <label>담당 반</label>
          <SelectOption
            optionData={selectOptionClass}
            onChange={(prop: number) => handleChangeOption(prop)}
          />
        </div>
      </MainSection>
      <button
        type="button"
        className="default-btn main-btn"
        disabled={!isRequired}
        onClick={() => goToNextPage("welcome")}
      >
        다음
      </button>
    </MainWrap>
  );
}

// [선생님] 등록
export function RegisterTeacher() {
  // ************************************ prop

  const signContext = useContext(SignContext);
  if (!signContext) {
    throw new Error("SignContext must be used within a SignProvider");
  }
  const { signData, setSignData } = signContext;

  const navigate = useNavigate();
  
  // ************************************ state

  const [loading, setLoading] = useState(false);
  // 공공데이터
  const [province, setProvince] = useState<provinceInfo[]>([]);
  // 시/도 선택
  const [selectData, setSelectData] = useState<selectDataType>({
    province: 0, district: 0
  });
  // 선택한 시도+시군구 전체
  const [provinceDistrict, setProvinceDistrict] = useState<any[]>([]);
  // 시군구 select-option
  const [district, setDistrict] = useState<provinceInfo[]>([
    { label: "선택", value: 0 },
  ]);
  // 학교(원) 검색 input
  const [inputText, setInputText] = useState("");
  // 학교(원) list
  const [siteList, setSiteList] = useState<SiteInfo[]>([]);
  const [totalCount, setTotalCount] = useState(0); // list 개수
  // 학교
  const [center, setCenter] = useState<{ site_id: number; site_name: string }>({
    site_id: 0, site_name: "",
  });

  // required 체크
  const [isRequired, setIsRequired] = useState(false);

  // ************************************ handle

  // 공공데이터
  const fetchData = async () => {
    try {
      // 토큰 루프 - 4시간
      tokenData = await getAccessToken();
      const response = await axios.get(API_URL, {
        params: {
          accessToken: tokenData,
        },
      });
      // 시/도만 추출
      let _data: provinceInfo[] = [{ label: "선택", value: 0 }];
      response.data.result.forEach((pro: any) =>
        _data.push({ label: pro.addr_name, value: pro.cd })
      );
      setProvince(_data);
      setLoading(true);
    } catch (error) {
      console.error("error ", error);
    }
  };

  // 시/도, 지역, 원 선택
  function handleChangeOption(prop: number, type: string) {
    // 시/도 선택 시 시/도의 지역 불러오기
    if (type === "province") {
      districtData(prop);
      setSelectData({ district: 0, province: prop });
      setDistrict([{ label: "선택", value: 0 }]);
    } else {
      setSelectData((prevData) => ({
        ...prevData,
        [type]: prop,
      }));
    }
  }

  // 시군구 데이터 API 가져오기
  const districtData = async (prop: number) => {
    try {
      const response = await axios.get(API_URL, {
        params: {
          accessToken: tokenData,
          cd: prop,
        },
      });
      // 시/도의 시군구 추출
      let _data: provinceInfo[] = [{ label: "선택", value: 0 }];
      if (response.data.errCd !== -200) {
        setProvinceDistrict(response.data.result);
        response.data.result.forEach((pro: any) =>
          _data.push({ label: pro.addr_name, value: pro.cd })
        );
      }
      setDistrict(_data);
    } catch (error) {
      console.error("error ", error);
    }
  };

  // 원 검색
  const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(event.target.value);
  };
  
  // 검색 버튼 클릭 시
  async function searchSite() {
    if (!(selectData.district && selectData.province)) {
      alert("소속된 원이 있는 시/도, 지역을 모두 선택해주세요.");
      return;
    }

    getSiteDatas();
  }
  
  // site가져오기
  const getSiteDatas = useCallback(async () => {

    const fullAddressData = provinceDistrict.find((data) => selectData.district === data.cd);
    const sido = fullAddressData.full_addr.substring(0, fullAddressData.full_addr.indexOf(" "));
    const sigungu = fullAddressData.addr_name;
    const props = { sido, sigungu, name: inputText }

    const result = await getSite(props);
    
    setTotalCount(result.total_count);
    if (result.code === 200) {
      setSiteList(result.data);
    } else {
      alert(result.message);
      return;
    }
  }, [selectData.district, inputText, provinceDistrict]);

  const handleRadioValue = (siteId: number, siteName: string) => {
    setCenter({ site_id: siteId, site_name: siteName });
  };

  async function goToNextPage(page: string) {
    setSignData((prev) => ({
      ...prev,
      site: {
        ...prev.site,
        name: center.site_name,
      },
      site_id: center.site_id,
    }));

    navigate(`${page}`);
    // navigate(`${page}`, {state: center.site_id });
  }
  
  // ************************************ useEffect

  // 지역이 선택될 때 해당 시도/지역/검색어를 가지고 Data 가져오기
  useEffect(() => {
    if (selectData.district) {
      getSiteDatas();
    }
    else setSiteList([]);
    setCenter({ site_id: 0, site_name: "" });
    setIsRequired(false);
  }, [selectData, getSiteDatas]);

  // 센터 하나를 선택하면 부모 component의 '다음'버튼 disabled=false
  useEffect(() => {
    if (center.site_id === 0) return;
    setIsRequired(true);
  }, [center]);

  useEffect(() => {
    setLoading(false);
    fetchData();
  }, []);

  return (
    <>
      {!loading ? <Loading /> : (
        <>
          <SignHeader
            title1={"소속된 학교의 선생님으로"}
            title2={"등록 요청해 주세요"}
            page={6}
          />
          <MainSection className="one-section">
            <div className="teacher-main-container">
              <div>
                <label>시/도</label>
                <SelectOption
                  optionData={province}
                  onChange={(prop: number) => handleChangeOption(prop, "province")}
                />
              </div>
              <div>
                <label>지역</label>
                <SelectOption
                  optionData={district}
                  onChange={(prop: number) => handleChangeOption(prop, "district")}
                />
              </div>
              <div>
                <label htmlFor="searchSite">학교 검색</label>
                <input
                  type="text"
                  id="searchSite"
                  value={inputText}
                  onChange={handleChangeValue}
                  placeholder="학교명 또는 전화번호 검색"
                />
                <div className="search-icon" onClick={searchSite}>
                  <img src="/image/icon/search.svg" alt="search" />
                </div>
              </div>
            </div>
            <DataResultWrap>
              <nav>
                <p>검색 결과</p>
                <p className="search-result-count">{totalCount}건</p>
              </nav>
              {totalCount ? (
                <div>
                  {siteList.map((site) => (
                    <CenterOneContainer key={site.id}>
                      <label htmlFor={`result${site.id}`}>
                        <div>
                          <p>{site.name}</p>
                          <p>{site.road_address}</p>
                          <p>{site.phone}</p>
                        </div>
                        <input
                          type="radio"
                          name="center"
                          id={`result${site.id}`}
                          value={site.name}
                          onChange={() => handleRadioValue(site.id, site.name)}
                        />
                      </label>
                    </CenterOneContainer>
                  ))}
                </div>
              ) : (
                <NoDataWithImageText text={NODATATEXT.noSite} />
              )}
            </DataResultWrap>
          </MainSection>
          <button
            type="button"
            className="default-btn main-btn"
            disabled={!isRequired}
            onClick={() => goToNextPage("registerClass")}>
            다음
          </button>
        </>
      )}
    </>
  );
}

// 설치형에서는 미사용
// [관리자] 학교 등록
export function RegisterCenter() {
  // ************************************ prop

  const signContext = useContext(SignContext);
  if (!signContext) {
    throw new Error("SignContext must be used within a SignProvider");
  }
  const { signData, setSignData } = signContext;
  const navigate = useNavigate();

  // ************************************ state

  // 입력정보
  const [inputData, setInputData] = useState<signSiteInfo>({
    center_name: "",
    name: "",
    full_address: "",
    address_detail: "",
    phone: "",
    telephone: "",
    email: "",
  });

  // 입력값 검사
  const [isRequired, setIsRequired] = useState(false);

  // ************************************ handle

  const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 주소 검색
  const open = useDaumPostcodePopup();
  // 카카오 지도 생성하기
  function openDaumPostcode(data: any) {
    // let postcode = data.zonecode; // 우편번호
    let roadFullAddress = data.roadAddress; // 도로명주소
    setInputData((prev) => ({
      ...prev,
      full_address: roadFullAddress,
    }));
  }
  function searchSite() {
    open({ onComplete: openDaumPostcode, theme: themeObj });
  }
  
  async function goToNextPage() {
    // 업장 우선 등록 후 정상 등록되면 사용자 등록
    const sitedata = {
      name: inputData.center_name,
      full_address: inputData.full_address,
      detail_address: inputData.address_detail,
      phone: inputData.telephone,
      email: inputData.email,
    };

    const siteResult = await postSignSite(sitedata);
    
    if (siteResult.code === 200) {
      const siteId = siteResult.data.id;
      // 회원가입이 정상적으로 진행되면 welcome 페이지로 이동
      const result = await postSignUser(signData, siteId);
      if (result.code === 200) navigate(`/login/welcome`);
      else if (result.code === 409) {
        alert("이미 등록된 사용자입니다.");
        return;
      }
      else {
        // 사용자 등록 실패 시 방금 등록한 site(siteId) 삭제해야함
        alert(result.message);
        return;
      }
    }
    else {
      alert(siteResult.message);
      return;
    }
  }
  
  // ************************************ useEffect

  // 상세주소, 이메일 필수입력값 제외
  useEffect(() => {
    let checkValid = Object.entries(inputData).filter(
      ([key, value]) => !(key === "address_detail" || key === "email") && value === ""
    );
    if (checkValid.length === 0) setIsRequired(true);
    else setIsRequired(false);

  }, [inputData, isRequired]);

  useEffect(() => {
    // name, phone 불러오기
    if (signData.user?.name !== undefined) {
      setInputData((prev) => ({
        ...prev,
        name: aesCBCDecrypt(signData.user?.name!),
        phone: aesCBCDecrypt(signData.user?.phone!),
      }));
    }
    else navigate(`/login/sign`);
  }, []);
  return (
    <>
      <SignHeader
        title1={"운영하고 있는 학교를"}
        title2={"등록해 주세요"}
        page={6}
      />
      <div className="devide-section-wrap">
        <MainSection className="devide-section">
          <div className="director-main-container">
            <div>
              <label htmlFor="center_name" className="required_value">학교 이름</label>
              <input
                type="text"
                id="center_name"
                name="center_name"
                value={inputData.center_name}
                onChange={handleChangeValue}
                placeholder="학교 이름 입력"
              />
            </div>
            <div>
              <label htmlFor="name" className="required_value">관리자명</label>
              <input
                type="text"
                id="name"
                name="name"
                value={inputData.name}
                onChange={handleChangeValue}
                placeholder="관리자명 입력"
                disabled
              />
            </div>
            <div>
              <label htmlFor="email">이메일</label>
              <input
                type="text"
                id="email"
                name="email"
                value={inputData.email}
                onChange={handleChangeValue}
                placeholder="이메일 입력"
              />
            </div>
            <div>
              <label htmlFor="phone" className="required_value">핸드폰번호</label>
              <input
                type="text"
                id="phone"
                name="phone"
                value={inputData.phone}
                onChange={handleChangeValue}
                placeholder="핸드폰번호 입력"
                disabled
              />
            </div>
            <div>
              <label htmlFor="telephone" className="required_value">학교 전화번호</label>
              <input
                type="text"
                id="telephone"
                name="telephone"
                value={inputData.telephone}
                onChange={handleChangeValue}
                placeholder="전화번호 입력"
              />
            </div>
          </div>
        </MainSection>
        <MainSection>
          <div className="director-main-container">
            <div>
              <label htmlFor="full_address" className="required_value">주소 검색</label>
              <input
                type="text"
                id="full_address"
                name="full_address"
                value={inputData.full_address}
                onChange={handleChangeValue}
                placeholder="주소 검색"
              />
              <div className="search-icon" onClick={searchSite}>
                <img src="/image/icon/search.svg" alt="search" />
              </div>
            </div>
            <div>
              <label htmlFor="address_detail"></label>
              <input
                type="text"
                id="address_detail"
                name="address_detail"
                value={inputData.address_detail}
                onChange={handleChangeValue}
                placeholder="상세주소 입력"
              />
            </div>
          </div>
        </MainSection>
      </div>
      <button
        type="button"
        className="default-btn main-btn"
        disabled={!isRequired}
        onClick={goToNextPage}
      >
        다음
      </button>
    </>
  );
}

// 학교에서는 미사용
// 원장님/선생님 확인
export function RegisterAccountType() {
  // ************************************ prop

  const navigate = useNavigate();
  // 원장님 or 선생님 선택 확인
  const { accountType } = useParams();

  useEffect(() => {
    if (!checkLoginPage &&
      (!sessionStorage.getItem("sessionData") ||
        !sessionStorage.getItem("sessionData")?.includes("user"))
    )
      navigate(`/login/sign`);
  }, []);

  return (
    <MainWrap>
      {accountType === "teacher" ? <RegisterTeacher /> : <RegisterCenter />}
    </MainWrap>
  );
}
